import { serializable, alias, object, list, primitive } from 'serializr';

export class FilterSalesReport {
    @serializable(alias('BoardId', primitive()))
    boardId?: number | string;

    @serializable(alias('GradeId', primitive()))
    branchClassRoomId?: number;

    @serializable(alias('StartDate', primitive()))
    startingDate?: string;

    @serializable(alias('EndDate', primitive()))
    endingDate?: string;
    
    @serializable(alias('status', primitive()))
    paymentStatus?: string;
}

export class SalesReportModel {
    @serializable(alias("studentName", primitive()))
    studentName?: string;
    @serializable(alias("productName", primitive()))
    productName?: string;
    @serializable(alias("purchaseDate", primitive()))
    purchaseDate?: string;
    @serializable(alias("status", primitive()))
    status?: string;
    @serializable(alias("transactionRefId", primitive()))
    transactionRefId?: string;
    @serializable(alias("transactionId", primitive()))
    transactionId?: string;
    @serializable(alias("invoiceNo", primitive()))
    invoiceNo?: string;
    @serializable(alias("invoiceLink", primitive()))
    invoiceLink?: string;
    @serializable(alias("amountPaid", primitive()))
    amountPaid?: string;
    @serializable(alias("email", primitive()))
    email?: string;
    @serializable(alias("mobileNo", primitive()))
    mobileNo?: string;

}